module.exports = __webpack_public_path__ + "img/2.579c6f6a.png";